<template>
  <div>
    <v-card flat>
      <v-card-title class="pa-2">
        <h3>{{$t(`${propertyObj.type}`)}} {{ $t('message.props.properties') }}</h3>
      </v-card-title>
      <v-card-text>
        <template v-if="propertyObj.type !== fieldTypeConstants.RADIOBOX">
          <v-checkbox :label="$t('message.props.isMultiSelect')" v-model="ismultiselect" class="ma-3" hide-details @change="propertyObj.typedata.isMultiSelect = ismultiselect"></v-checkbox>
        </template>
        <template>
          <options-list ref="optionListForm" :list="listItems" :type="18" :ismultiselect="ismultiselect" :fieldType="propertyObj.type" class="ml-5 mt-3"></options-list>
        </template>
      </v-card-text>
      <v-card-actions class="text-center">
        <v-row justify="center" class="ma-0">
          <v-btn class="mx-1" color="info" @click="submitTypeData">OK</v-btn>
          <v-btn class="mx-1" color="error" @click="cancel">Cancel</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import dataGridConstants from '@/mixins/Checklist/data_grid_component'
export default {
  mixins: [dataGridConstants],
  props: {
    propertyObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      listItems: this.$formatter.cloneVariable(this.propertyObj.typedata.listItems),
      ismultiselect: this.propertyObj.typedata.isMultiSelect,
      optionsValueNotUnique: false
    }
  },
  methods: {
    submitTypeData () {
      if (this.$refs.optionListForm.$refs.optionsList.validate() && this.isOptionsValid()) {
        this.propertyObj.typedata.listItems = this.$formatter.cloneVariable(this.listItems)
        this.$emit('saveClick', this.propertyObj)
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.optionsValueNotUnique ? this.$t('message.props.optionsValuesAreNotUnique') : this.$t('message.common.validationIssue') })
      }
    },
    isOptionsValid () {
      let isOptionsListValid = true
      if (this.listItems.length) {
        const hasDuplicate = this.$formatter.optionsValuesDuplication(this.listItems)
        const isValid = this.$refs.optionListForm.$refs.optionsList.validate()
        isOptionsListValid = isValid && !hasDuplicate
        this.optionsValueNotUnique = isValid && hasDuplicate
      }
      return isOptionsListValid
    },
    cancel () {
      this.$emit('cancelClick')
    }
  },
  components: {
    OptionsList: () => import('../OptionsList')
  }
}
</script>
